"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Opacity = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "3 3 18 18"
}, props), _react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  fill: "#FFF",
  d: "M-457-743H737V91H-457z"
}), _react.default.createElement("g", null, _react.default.createElement("use", {
  fill: "#000",
  filter: "url(#a)",
  xlinkHref: "#b"
}), _react.default.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#b"
})), _react.default.createElement("path", {
  d: "M12 3a9 9 0 01.265 17.996L12 21a9 9 0 010-18zm4.897 14.002L12 17v2a6.977 6.977 0 004.897-1.998zM12 13v2h6.326a6.95 6.95 0 00.603-1.999L12 13zm0-8v2h4.898A6.977 6.977 0 0012 5zm0 6h6.93a6.95 6.95 0 00-.604-2H12v2z",
  className: "fill"
})));

var _default = Opacity;
exports.default = _default;